import { combineReducers } from 'redux';
import block from './block/blockReducer';
import objectstore from './objectstore/objectstoreReducer';

export default combineReducers({
	block,
	objectstore,
});
